module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAYAAAA7bUf6AAABY0lEQVQ4jZ3Tu0sdURDH8Y+6BkFRJESsFItgJSSIRVKEFJaCN1U6sUsRUogE0l1LAyklcAv/AS3ChZSBdGkUtBEVi9zYXB+EWOQheXAtdlZl2TWJP1h2zpmZ786cs9NmYV1OjzCKxbwDL7CLN9lGqzouCbsD93ETzzCCnQLIE3xEC5/xAX/aLKz34h0mCpL+pjVMtmMOd1CJClawHXb+2cZq2JXIm0swFsR60F9iEI2CL8/jMHyNyBtLOD+Xh5eCv+fWmX6gN+dLMkAf3pc1foW2cJxBTnD3GpAlLlr5jU08xa1Le69wii48l/4KcITXEXMOyfQYQ2H/wjKa6McMOsO3HxBFkAclZTdxu6ynPKSO4bB/YipKH8Bb3AjfJ0yXQTbxJexv0qsW7zV0x7pxVSXVkoq/Sg+9UO04kE5tT1lQiXoi7yBBDbPYk475v2pUemu1BBu4Jx3zwf+A1FFrVcc3zgA24Ep49HVCMQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/date.png
// module id = e5L/
// module chunks = 1